import { FC } from 'react';
import { HeadLine } from 'atoms/Typography/Typography';
import styles from './styles.module.css';

/**
 * @deprecated Title is deprecated, use HeadLine directly
 */

export const Title: FC<{ text: string }> = ({ text }) => {
  return (
    <HeadLine type="md" tag="h1" className={styles.title}>
      {text}
    </HeadLine>
  );
};
